import { apiClient } from '@/lib/api';
import type {
  EdiphorTokenInfoDto,
  EdiphorCustomPredictRequestDto,
  EdiphorPredictResponseDto,
  EdiphorPipelineRequestDto,
  EdiphorPipelineResponseDto,
  EdiphorPollResultDto,
  EdiphorPollHistoryDto
} from '@/features/diagnostics/types';

const BASE_PATH = '/api/v1/diagnostics/ediphor';

export const ediphorDiagnosticsService = {
  async getTokenInfo(): Promise<EdiphorTokenInfoDto> {
    const response = await apiClient.get(`${BASE_PATH}/token-info`);
    return response.data;
  },

  async invalidateTokens(): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.delete(`${BASE_PATH}/tokens`);
    return response.data;
  },

  async forceAuthenticate(): Promise<EdiphorTokenInfoDto> {
    const response = await apiClient.post(`${BASE_PATH}/authenticate`);
    return response.data;
  },

  async submitCustomPredict(
    request: EdiphorCustomPredictRequestDto
  ): Promise<EdiphorPredictResponseDto> {
    const response = await apiClient.post(`${BASE_PATH}/predict`, request);
    return response.data;
  },

  async runPipeline(
    request: EdiphorPipelineRequestDto
  ): Promise<EdiphorPipelineResponseDto> {
    const response = await apiClient.post(`${BASE_PATH}/pipeline`, request);
    return response.data;
  },

  async pollRequest(requestId: number): Promise<EdiphorPollResultDto> {
    const response = await apiClient.get(`${BASE_PATH}/poll/${requestId}`);
    return response.data;
  },

  async getPollingHistory(
    since?: Date,
    limit?: number
  ): Promise<EdiphorPollHistoryDto> {
    const params = new URLSearchParams();
    if (since) params.append('since', since.toISOString());
    if (limit) params.append('limit', limit.toString());

    const queryString = params.toString();
    const response = await apiClient.get(
      `${BASE_PATH}/polling-history${queryString ? `?${queryString}` : ''}`
    );
    return response.data;
  }
};
